/**
 * Configuración → Maestros. Reescrito en JSX legible el 2026-10-07: cada
 * pestaña se muestra según el permiso que la administra (Usuarios, Sedes,
 * Fundos, Concesionarias). Los roles ya no se usan: los reemplazan los
 * permisos por acción de cada usuario.
 */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fundos as Fundos,
  rec_React as React,
  rec_Roles as Roles,
  rec_Usuarios as Usuarios,
  rec_puedeAccion as puedeAccion,
} from "../../runtime/index.jsx";
import { Concesionarias } from "./Concesionarias.jsx";

// runtime/index.jsx importa este archivo antes de definir React (import circular).
const useState = (...a) => React.useState(...a);

const PESTANAS = [
  { id: `usuarios`, label: `Usuarios`, permisos: [`sistema.usuarios.ver`, `sistema.usuarios.permisos`] },
  { id: `sedes`, label: `Sedes`, permisos: [`sistema.maestros.sedes`] },
  { id: `fundos`, label: `Fundos`, permisos: [`sistema.maestros.fundos`] },
  { id: `concesionarias`, label: `Concesionarias`, permisos: [`sistema.maestros.concesionarias`] },
];

export function Maestros() {
  const visibles = PESTANAS.filter((p) => p.permisos.some((c) => puedeAccion(c)));
  const [elegida, setElegida] = useState(visibles[0]?.id ?? null);
  if (!visibles.length) return <AccesoDenegado />;
  const actual = visibles.some((p) => p.id === elegida) ? elegida : visibles[0].id;
  return (
    <EstructuraPrincipal title={`Administración`}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap gap-1 border-b border-(--border)">
          {visibles.map((p) => (
            <button key={p.id} type="button" onClick={() => setElegida(p.id)}
              className={`-mb-px border-b-2 px-3 py-2 text-sm transition ${actual === p.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}>
              {p.label}
            </button>
          ))}
        </div>
        {actual === `usuarios` ? <Usuarios /> : actual === `fundos` ? <Fundos /> : actual === `concesionarias` ? <Concesionarias /> : <Roles key={actual} recurso={actual} />}
      </div>
    </EstructuraPrincipal>
  );
}
